/* global gtag */
import React, { useState } from "react";
import { Table, Spinner, Button } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faSearch,
  faSort,
  faChevronDown,
  faChevronUp,
  faHistory,
} from "@fortawesome/free-solid-svg-icons";
import { formatDate } from "../../utils/functions";
import api from "../../services/client/api";
import Justification from "../../components/Justification/index.jsx";
import { useHistory } from "react-router-dom";
import { deleteCookies } from "../../utils/functions";
import { ButtonRedFlag, ButtonOrder, ButtonShow } from "./styles";

export default function ListReports({ reports, token, username }) {
  const [downloading, setDownloading] = useState({ numberReport: null });
  const [sortOrder, setSortOrder] = useState("desc");
  const [showJustification, setShowJustification] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);
  const [isTableExpanded, setIsTableExpanded] = useState(true);
  const [downloadClickedId, setDownloadClickedId] = useState(null);

  let history = useHistory();

  const download = async (
    numberReport,
    typeReport,
    hashMatriz,
    reportInstancia,
    win,
  ) => {
    setDownloading({ numberReport: numberReport });
    setDownloadClickedId(numberReport);
    let statusCode;
    try {
      const response = await api()
        .report()
        .download(token, numberReport, typeReport, hashMatriz);

      reportInstancia.hash_matriz = response.output;

      statusCode = response.status;

      if (statusCode === 401) {
        await deleteCookies();
        history.replace({ pathname: "/login" });
      }

      if (statusCode === 200) {
        const fileName = response.output; // ex: abc123.pdf
        const fileUrl = `https://apiv4.cedap.com.br/tmp/${fileName}`;

        const fileResponse = await fetch(fileUrl);
        const blob = await fileResponse.blob();

        const blobUrl = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = blobUrl;
        a.download = fileName; // força download
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(blobUrl);
      }
    } catch (error) {
      console.error("Erro no download:", error);
    }

    setDownloading({ numberReport: null });
  };

  if (reports.length < 1) {
    return <div>Nenhum resultado encontrado.</div>;
  }

  const toggleSortOrder = () => {
    setSortOrder((prevOrder) => (prevOrder === "desc" ? "asc" : "desc"));
  };

  const toggleTableVisibility = () => {
    setIsTableExpanded((prev) => !prev);
  };

  setTimeout(() => {
    setDownloadClickedId(null);
  }, 30000); // some após 30 segundos

  const sortedReports = reports.sort((a, b) => {
    return sortOrder === "desc"
      ? new Date(b.request_date) - new Date(a.request_date)
      : new Date(a.request_date) - new Date(b.request_date);
  });

  const handleShowJustification = (report) => {
    // ✅ GA4: TimeLine Show
    gtag("event", "view_timeline", {
      event_category: "timeline_view",
      value: 200,
    });
    setSelectedReport(report);
    setShowJustification(true);
  };

  const handleCloseJustification = () => {
    setShowJustification(false);
  };

  return (
    <div style={{ marginTop: "30px" }}>
      <h5>
        <FontAwesomeIcon icon={faSearch} /> {sortedReports.length} resultados:
      </h5>

      <ButtonShow
        color="secondary"
        onClick={toggleTableVisibility}
        style={{ marginBottom: "10px" }}
      >
        {isTableExpanded ? (
          <>
            Ocultar exames <FontAwesomeIcon icon={faChevronUp} />
          </>
        ) : (
          <>
            Mostrar exames <FontAwesomeIcon icon={faChevronDown} />
          </>
        )}
      </ButtonShow>

      {(isTableExpanded || sortedReports.length === 1) && (
        <>
          {/* Botão de ordenação movido para fora da tabela */}
          <div style={{ marginBottom: "10px" }}>
            <ButtonOrder color="info" onClick={toggleSortOrder}>
              <FontAwesomeIcon icon={faSort} /> Ordenando por{" "}
              {sortOrder === "desc" ? "mais recente" : "mais antigo"}
            </ButtonOrder>
          </div>

          {/* Tabela */}
          <Table striped bordered responsive style={{ marginTop: "5px" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "center" }}>Data solicitação</th>
                <th style={{ textAlign: "center" }}>Disponibilidade</th>
                <th style={{ textAlign: "center" }}>Nº do Exame</th>
                <th style={{ textAlign: "center" }}>Instituição de origem</th>
              </tr>
            </thead>
            <tbody>
              {sortedReports.map((report) => (
                <tr key={report.id_exam}>
                  <td style={{ textAlign: "center" }}>
                    {formatDate(report.request_date)}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {showJustification &&
                      selectedReport &&
                      selectedReport.id_exam === report.id_exam && (
                        <Justification
                          token={token}
                          username={username}
                          onClose={handleCloseJustification}
                          cod_request={selectedReport.id_exam}
                          cod_event={selectedReport.cod_event}
                          cod_report={selectedReport.cod_report}
                          expected_date={selectedReport.expected_date}
                        />
                      )}

                    {report.lib_web === false ? (
                      <ButtonRedFlag
                        disabled={downloading.numberReport === report.id_exam}
                        color="danger"
                        onClick={() => handleShowJustification(report)}
                      >
                        {downloading.numberReport === report.id_exam ? (
                          <>
                            <Spinner color="primary" /> Downloading
                          </>
                        ) : (
                          <>
                            <FontAwesomeIcon icon={faHistory} /> Status do Exame
                          </>
                        )}
                      </ButtonRedFlag>
                    ) : (
                      <Button
                        size="sm"
                        disabled={downloading.numberReport === report.id_exam}
                        color="primary"
                        onClick={() =>
                          download(
                            report.id_exam,
                            report.type,
                            report.hash_matriz,
                            report,
                          )
                        }
                      >
                        {downloading.numberReport === report.id_exam ? (
                          <>
                            <Spinner color="primary" /> Downloading
                          </>
                        ) : (
                          <>
                            <FontAwesomeIcon icon={faDownload} /> Download
                          </>
                        )}
                      </Button>
                    )}
                    <>
                      {downloadClickedId === report.id_exam && (
                        <div
                          style={{
                            marginTop: "8px",
                            fontSize: "13px",
                            color: "#666",
                          }}
                        >
                          Problemas ao abrir?{" "}
                          <a
                            href={`https://apiv4.cedap.com.br/tmp/${report.hash_matriz}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Clique aqui para baixar novamente.
                          </a>
                        </div>
                      )}
                    </>
                  </td>
                  <th scope="row" style={{ textAlign: "center" }}>
                    {report.id_exam}
                  </th>
                  <td style={{ textAlign: "center" }}>{report.institution}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </>
      )}
    </div>
  );
}
